import SkillsTabs from './SkillsTabs';

export default SkillsTabs